import React, { useState, useEffect } from 'react';
import { API } from '../contexts/AuthContext';
import axios from 'axios';

export default function MeuPerfil() {
  const [perfil, setPerfil] = useState(null);

  useEffect(() => {
    axios.get(`${API}/perfil`).then(res => setPerfil(res.data)).catch(() => {});
  }, []);

  if (!perfil) return <div className="text-center py-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;

  return (
    <div>
      <h4 className="fw-bold mb-4">Meu Perfil</h4>
      <div className="card p-4" style={{ maxWidth: 500 }}>
        <div className="mb-3">
          <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>Nome</label>
          <p className="mb-0">{perfil.nome}</p>
        </div>
        <div className="mb-3">
          <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>Perfil</label>
          <p className="mb-0">{perfil.perfil_nome}</p>
        </div>
        {perfil.filial_nome && (
          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>Filial</label>
            <p className="mb-0">{perfil.filial_nome}</p>
          </div>
        )}
        <div style={{ color: '#999', fontSize: '0.8rem', marginTop: 12 }}>
          Para alterar sua senha, entre em contato com o administrador do Centrão.
        </div>
      </div>
    </div>
  );
}
